<template>
    <section class="subpage__content">
        <div class="subpage__inner">
            <!--상단_레이아웃 -->
            <div class="flex justify-between align-center serch__field">
                <p class="input__box">
                    <q-input outlined v-model="keyword" @keyup.enter="onSearch" debounce="500" placeholder="작품찾기" class="serch">
                        <template v-slot:append>
                            <q-icon name="img:/assets/images/icon/ico_serch.svg" @click="onSearch" />
                            <!-- <q-icon name="search" @click="onSearch" size="50px" style="top: 14px" /> -->
                        </template>
                    </q-input>
                </p>
                <CusButton :type="472" :label="`필터 선택`" @onReturn="popFilter = true" />
            </div>

            <!--검색결과 -->
            <div class="table__border">
                <div class="table__content">
                    <table class="table table--line table-header--sticky report__table">
                        <thead>
                            <tr>
                                <th>영역</th>
                                <th>학습 개념 상세</th>
                                <th>갈래/주제</th>
                                <th>제목</th>
                                <th>글쓴이</th>
                                <th>학습 레슨</th>
                                <th>학습일</th>
                                <th>성취율</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in rows" :key="i + item">
                                <td>{{ item.areaName }}</td>
                                <td>{{ item.passageConcept }}</td>
                                <td>{{ item.passageClass }}</td>
                                <td>{{ item.passageName }}</td>
                                <td>{{ item.writerName }}</td>
                                <td>{{ item.levelLessonStr }}</td>
                                <td>{{ item.learningEndTs ? item.learningEndTs : '-' }}</td>
                                <td>{{ item.passageAccuracyRate ? item.passageAccuracyRate + '%' : '학습전' }}</td>
                                <!-- <td>{{ item.learningEndTs }}</td>
                                    <td>{{ item.passageAccuracyRate ? item.passageAccuracyRate + '%' : '' }}</td> -->
                            </tr>
                            <tr v-if="totalData && rows < 1" class="none-data">
                                <td colspan="8">검색어와 일치하는 결과가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> 
        </div>
    </section>

    <q-dialog v-model="popFilter" class="modal">
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-btn class="close" icon="close" flat v-close-popup />
            </q-card-section>

            <q-separator />

            <div class="modal__content">
                <div class="level-select">
                    <div class="flex justify-between align-center">
                        <h3 class="title">레벨 선택</h3>
                        <q-btn unelevated no-ripple :onClick="onInitFilter">
                            <span class="button small black-outline">필터 초기화</span>
                        </q-btn>
                    </div>
                    <!-- 상단_체크박스 -->
                    <div class="flex justify-between align-center">
                        <CusCheck :id="isAll1.label" :label="isAll1.label" v-model:checked="isAll1.checked" @onReturn="onAll1" />
                        <template v-for="(e, i) in cbList1" :key="i">
                            <CusCheck :id="e.label" :label="e.label" v-model:checked="e.checked" />
                        </template>
                    </div>
                </div>
                <div class="subject-select">
                    <h3 class="title">갈래/주제 선택</h3>
                    <!-- 하단_체크박스 -->
                    <CusCheck :id="isAll2.label" :label="isAll2.label" v-model:checked="isAll2.checked" @onReturn="onAll2" />
                    <div class="flex align-center">
                        <template v-for="(e, i) in cbList2" :key="i">
                            <CusCheck :id="e.label" :label="e.label" v-model:checked="e.checked" />
                        </template>
                    </div>
                </div>
                <!-- 하단버튼 -->
                <p class="button__content">
                    <CusButton :type="560" :label="`필터 적용`" @onReturn="onCompleteFilter" />
                </p>
            </div>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { onMounted, ref, reactive, watch } from 'vue';
import { searchContents } from '@/api/modules/user_map.js';
import DialogFilter from '@/views/userMapMain/DialogFilter.vue';
import CusCheck from '@/components/widget/CusCheck.vue';
import CusButton from '@/components/widget/CusButton.vue';

import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import CqBtn from '@/components/quasar/cqBtn.vue';
import cqBtnVue from '@/components/quasar/cqBtn.vue';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const isDisableBtn = ref(false);
const rows = ref();
let totalData, resultData;
const keyword = ref();

//---------------필터다이얼로그_START----------------//
//---------------상단----------------//
const popFilter = ref(false);
const isAll1 = ref({ checked: true, value: '1', label: '모든 레벨' });
const onAll1 = (bool) => {
    cbList1.value.forEach((e) => (e.checked = bool));
};
const cbList1 = ref([
    { checked: true, value: '1', label: '1레벨' },
    { checked: true, value: '2', label: '2레벨' },
    { checked: true, value: '3', label: '3레벨' },
]);
watch(cbList1.value, (nObj) => {
    isAll1.value.checked = nObj.filter((e) => e.checked).length === nObj.length;
});

//---------------하단----------------//
const isAll2 = ref({ checked: true, value: '1', label: '모든 영역' });
const onAll2 = (bool) => {
    cbList2.value.forEach((e) => (e.checked = bool));
};
const cbList2 = ref([
    { checked: true, value: 'Y1_01', label: '현대시' },
    { checked: true, value: 'Y1_02', label: '현대소설' },
    { checked: true, value: 'Y1_03', label: '고전시가' },
    { checked: true, value: 'Y1_04', label: '고전산문' },
    { checked: true, value: 'Y1_05', label: '극수필' },
    { checked: true, value: 'Y5_01', label: '인문' },
    { checked: true, value: 'Y5_02', label: '과학' },
    { checked: true, value: 'Y5_03', label: '정치사회' },
    { checked: true, value: 'Y5_04', label: '예술' },
    { checked: true, value: 'Y5_05', label: '기술' },
    { checked: true, value: 'Y5_06', label: '경제문화' },
    { checked: true, value: 'Y5_07', label: '융합' },
]);
watch(cbList2.value, (nObj) => {
    isAll2.value.checked = nObj.filter((e) => e.checked).length === nObj.length;
});

const onInitFilter = () => {
    onAll1(true);
    onAll2(true);
};
//---------------필터다이얼로그_END----------------//
//-------------api검색 ---------------//
const setData = async () => {
    const selector1 = cbList1.value.filter((e) => e.checked).map((e) => e.value);
    const selector2 = cbList2.value.filter((e) => e.checked).map((e) => e.value);
    const res = await searchContents(gStore.token, selector1, selector2);
    // console.log('--contents--res:', res);
    if (res && res.status === 200) {
        if (!totalData) totalData = res.data.data; // 처음에만 데이타 저장
        rows.value = res.data.data;
    }
};

onMounted(() => {
    setData();
});

////////////////////////////----OnClick----////////////////////////////

const onHome = () => {
    router.push('/learninghome');
};
const onSearch = () => {
    // keyword.value = keyword.value ? keyword.value.replace(/ /g, '') : '';
    const word = keyword.value;

    if (word) rows.value = totalData.filter((e) => e.passageName.includes(word));
    else rows.value = totalData;
};

const onCompleteFilter = () => {
    popFilter.value = false;
    setData();
};
</script>

<style scoped lang="scss">
::v-deep {
    .serch__field {
        .q-field--outlined .q-field__control {
            align-items: center;
            height: inherit;
            padding: 0 1.6vw;
            @include border-radius(0.8vw);
        }

        .q-field__native,
        .q-field__input {
            padding: 1vw 0;
            font-size: 1.2vw;
            line-height: 1.6vw;
        }

        .q-field__native::placeholder,
        .q-field__input::placeholder {
            color: $color_gray_600;
        }

        .q-field__marginal {
            width: 2.4vw;
            height: 2.4vw;
            margin-left: 0.8vw;
            padding: 0;
        }

        .q-icon {
            width: 100%;
            height: 100%;
        }
    }
}

.modal {
    p {
        margin-bottom: 0;
    }
    .q-dialog__inner--minimized > div {
        // width: 55%;
        // max-width: 1072px;
        width: 53.6vw;
        max-width: inherit;
        @include border-radius(2vw);
    }

    .modal__content {
        // padding: 2.45vw 2.8vw 2vw;
        padding: 4.08vmin 2.8vw 3.33vmin;
    }

    .q-card__section--vert {
        // padding: 1.65vw 2.8vw;
        padding: 2.75vmin 2.8vw;
    }

    .close {
        width: 2.4vw;
        height: 2.4vw;
        min-height: inherit;
        padding: 0;
        font-size: 1.2vw;
    }
    .align-center {
        align-items: center;
    }

    .title {
        margin: 0;
        font-size: 1.5vw;
        font-weight: 700;
        line-height: 1.9vw;
    }
    .level-select {
        > .flex {
             // margin-bottom: 2.4vw;
            margin-bottom: 4.08vmin;
        }
        .q-btn {
            padding: 0;
        }

        .input__box {
            width: 7.75vw;
        }
    }

    .subject-select {
        // margin-top: 3vw;
        // padding-top: 3vw;
        margin-top: 5vmin;
        padding-top: 5vmin;
        border-top: 1px solid $color_gray_400;

        .title {
            // margin-bottom: 2.4vw;
            margin-bottom: 4.08vmin;
        }
        .flex .input__box {
            // margin-top: 1.25vw;
            margin-top: 2vmin;
            margin-right: 2vw;
            width: 7.6vw;
        }
        .flex .input__box:nth-of-type(5),
        .flex .input__box:nth-of-type(10) {
            margin-right: 0;
        }
    }

    .button__content {
        width: 25vw;
        // margin: 3vw auto 0;
        margin: 5vmin auto 0;
    }
}
/*
@include pc_full {
    .modal {
        .q-dialog__inner--minimized > div {
            width: 58%;
        }
    }
}
*/
</style>
